import { render, staticRenderFns } from "./Caas-web.vue?vue&type=template&id=f453dbca&scoped=true"
import script from "./Caas-web.vue?vue&type=script&lang=js"
export * from "./Caas-web.vue?vue&type=script&lang=js"
import style0 from "./Caas-web.vue?vue&type=style&index=0&id=f453dbca&prod&lang=less&scoped=true"
import style1 from "./Caas-web.vue?vue&type=style&index=1&id=f453dbca&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f453dbca",
  null
  
)

export default component.exports